import { render, staticRenderFns } from "./myCustomerInfo.vue?vue&type=template&id=9839a854"
import script from "./myCustomerInfo.vue?vue&type=script&lang=js"
export * from "./myCustomerInfo.vue?vue&type=script&lang=js"
import style0 from "./myCustomerInfo.vue?vue&type=style&index=0&id=9839a854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports